import CreateContract from "features/Agent/Contract/Create";

function CreateContractScreen() {
  return <CreateContract />;
}

export default CreateContractScreen;
